import FormattedMessage from 'I18n/components/FormattedMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import { CLONE_VALIDATION_ERRORS } from 'asset-actions-lib-forms/constants/formCloning';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  FORM_NAME_TOO_LONG
} = CLONE_VALIDATION_ERRORS;
function getCloningErrorMessageKey(errorCode) {
  if (!errorCode) {
    return 'assetActionsLibForms.modals.cloneDialog.savingError.failureReasons.UNKNOWN';
  } else if (errorCode === FORM_NAME_TOO_LONG) {
    return 'assetActionsLibForms.modals.cloneDialog.savingError.failureReasons.FORM_NAME_TOO_LONG';
  }
  const errorKey = `assetActionsLibForms.modals.cloneDialog.savingError.failureReasons.${errorCode}`;
  if (isValidI18nKey(errorKey)) {
    return errorKey;
  }
  return 'assetActionsLibForms.modals.cloneDialog.savingError.failureReasons.UNKNOWN';
}

/**
 * Taken from https://git.hubteam.com/HubSpot/submissions-ui/blob/6cd4a17fdc3c51e98039f87cd318b6fb6fa55f1c/submissions-ui/static/js/components/formCloning/formCloningDialog/FormNameValidationMessage.js
 */
export default function FormNameValidationMessage({
  errorCode,
  isNameValid
}) {
  if (!isNameValid) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: getCloningErrorMessageKey(FORM_NAME_TOO_LONG)
    });
  }
  if (!errorCode) {
    return null;
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: getCloningErrorMessageKey(errorCode)
  });
}